<template>
    <div id="app" class="page-component__scroll">
        <headerMenu></headerMenu>
        <div class="app-top"></div>
        <router-view />
        <customerFooter v-if="route.name !== 'parterDialog'"></customerFooter>
        <el-backtop :bottom="100">
            <img id="re_top" class="re-top" :src="reTopUrl" />
        </el-backtop>
    </div>
</template>

<script>
import customerFooter from "@/components/customFooter.vue";
import headerMenu from "@/components/headerMenu.vue";


export default {
    data() {
        return {
            reTopUrl: require("./assets/re-top.svg"),
        };
    },
    name: "App",
    components: { customerFooter, headerMenu },
    computed: {
        route() {
            return this. $route
        }
    }
    // mounted() {
    // window.addEventListener("resize", () => {
    //     this.onRefresh();
    // });
    // },
    // methods: {
    // onRefresh() {
    //     this.$router.go(0)
    // }
    // },

    // destroyed() {
    //     window.removeEventListener('resize', this.onRefresh())
    // }
};
</script>

<style lang="less">
* {
    margin: 0;
    padding: 0;
}

.app-top {
    width: 100%;
    margin-top: 70px;
    background-color: #fff;
}
.re-top {
    border-radius: 50%;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue